import React from 'react'
import { useState, useRef } from 'react'
import link_icon from './img/link.svg'
import { useDebounce } from '../../../../hooks/useDebounce'
import "./QuestionAnswer.scss"


const QuestionAnswer = (({
    id,
    data,
    changeContent,
    setIsModal,
    ind,
    setCurrentIndex,
    before,
    setBeforeBlock,
    setContentArr,
    readonly = false,
}) => {
    const [content, setContent] = useState(data[0]?.value)
    const ref = useRef()

    const debounceChange = useDebounce(changeContent, 1000)

    const handleInput = (e) => {
        debounceChange(id,
            [
                {
                    value: ref?.current?.innerHTML,
                    properties: {
                        answerValue: answerRef?.current?.innerHTML
                    }
                }
            ]
        )
        setContentArr((prev) => {
            return prev.map((el) => {
                if (el?.block_id == id) {
                    return {
                        ...el,
                        content: [
                            {
                                value: ref?.current?.innerHTML
                            }
                        ]
                    }
                } else {
                    return el
                }
            })
        })
    }

    const handlePaste = (event) => {
        event.preventDefault();

        let clipboardData = event.clipboardData || window.clipboardData;
        let pastedHTML = clipboardData.getData('text/html') || clipboardData.getData('text/plain');

        if (pastedHTML) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(pastedHTML, 'text/html');

            // Удаляем все теги <br>
            doc.querySelectorAll('br').forEach(el => el.remove());

            // Оставляем только безопасные теги
            const allowedTags = ['p', 'b', 'i', 'u', 'a'];
            doc.body.querySelectorAll('*').forEach(el => {
                if (!allowedTags.includes(el.tagName.toLowerCase())) {
                    el.replaceWith(...el.childNodes); // Заменяем на чистый текст
                }
            });

            let cleanHTML = doc.body.innerHTML;

            // Вставляем очищенный HTML без форматирования
            document.execCommand('insertHTML', false, cleanHTML);
        }
    }

    // ответ 
    const [answer, setAnswer] = useState(data[0]?.properties?.answerValue || '') // предполагаем, что это второй элемент

    const answerRef = useRef()

    return (
        // <EditWrapper
        //     id={id}
        //     before={before}
        //     setIsModalView={setIsModalView}
        //     articleId={articleId}
        //     changeBlock={changeBlock}
        //     readonly={readonly}
        //     draggableElement={draggableElement}
        //     setDraggableElement={setDraggableElement}
        //     fetchDataById={fetchDataById}
        //     deleteFunc={(e) => handleDeleteBlock(id)}
        //     type='question'
        //     ind={ind}
        //     currentIndex={currentIndex}
        //     setCurrentIndex={setCurrentIndex}
        //     addNewBlock={addNewBlock}
        //     child={
        <div
            className={'questions__item'}
            onContextMenu={(e) => {
                if (!readonly) {
                    e.preventDefault()
                    setCurrentIndex(ind)
                    setIsModal(true)
                }
            }}
        >
            <div className={'questions__title-box'}>
                <a className={'questions__link-title'} href={`#${id}`}>
                    <h3
                        id={id}
                        className={`questions__title-questions`}
                        maxLength={20}
                        suppressContentEditableWarning
                        ref={ref}
                        // className={`article__title`}
                        contentEditable={!readonly}
                        dangerouslySetInnerHTML={{ __html: content }}
                        onInput={(e) => handleInput(e, ref, 'value')}
                        onPaste={handlePaste}
                        onClick={(e) => {
                            setCurrentIndex(ind)
                            setBeforeBlock(before)
                        }}
                    ></h3 >
                </a>
                <button
                    onClick={(e) => {
                        const fullUrlWithoutHash = window.location.origin + window.location.pathname + window.location.search;
                        alert(fullUrlWithoutHash + `#${id}`)
                        navigator.clipboard.writeText(fullUrlWithoutHash + `#${id}`)
                    }}
                    className={'questions__btn-link'}>
                    <img src={link_icon} />
                </button>
            </div>

            <div itemProp="acceptedAnswer" itemScope itemType="https://schema.org/Answer"
                className={'questions__response-box'}>
                <p itemProp="text"
                    className={'questions__text-response'}
                    suppressContentEditableWarning
                    ref={answerRef}
                    contentEditable={!readonly}
                    dangerouslySetInnerHTML={{ __html: answer }}
                    // onInput={handleAnswerInput}
                    onInput={(e) => handleInput(e, answerRef, 'answerValue')}
                    onPaste={handlePaste}
                    onClick={(e) => {
                        setCurrentIndex(ind)
                        setBeforeBlock(before)
                    }}
                />
            </div>
        </div>
    )
})

export { QuestionAnswer }